import { YStack, YStackProps } from '@my/ui'
import { Image } from 'app/types'
import { SolitoImage } from 'solito/image'

export interface GroupCardCoverProps {
  coverImage?: Image
  imagePriority?: boolean
}

export const GroupCardCover = ({
  coverImage,
  imagePriority,
  ...props
}: GroupCardCoverProps & YStackProps) => {
  if (!coverImage?.url) return null
  return (
    <YStack flexGrow={1} w="100%" aspectRatio={36 / 19} overflow="hidden" br="$2" {...props}>
      <SolitoImage
        src={coverImage.url}
        alt={coverImage.alt || ''}
        priority={imagePriority}
        contentFit="cover"
        fill
      />
    </YStack>
  )
}
